<div class="accordion" id="summaryAccordion">

  <!-- 1. Kişisel Bilgiler -->
  <div class="accordion-item">
    <h2 class="accordion-header" id="headingOne">
      <button class="accordion-button" type="button" data-bs-toggle="collapse" data-bs-target="#collapseOne"
        aria-expanded="true" aria-controls="collapseOne">
        Kişisel Bilgiler
      </button>
    </h2>
    <div id="collapseOne" class="accordion-collapse collapse show" aria-labelledby="headingOne"
      data-bs-parent="#summaryAccordion">
      <div class="accordion-body row">
        <div class="col-md-6">
          <strong>TC Kimlik No:</strong> {{ newPatientInformationForm.get('tckn')?.value }}
        </div>
        <div class="col-md-6">
          <strong>Ad Soyad:</strong>
          {{ newPatientInformationForm.get('name')?.value }}
          {{ newPatientInformationForm.get('lastName')?.value }}
        </div>
        <div class="col-md-6">
          <strong>Cinsiyet:</strong> {{ newPatientInformationForm.get('gender')?.value == "1" ? 'Erkek' : 'Kadın' }}
        </div>
        <div class="col-md-6">
          <strong>Doğum Tarihi:</strong> {{ newPatientInformationForm.get('birthDate')?.value }}
        </div>
        <div class="col-md-6">
          <strong>Email:</strong> {{ newPatientInformationForm.get('email')?.value }}
        </div>
        <div class="col-md-6">
          <strong>Telefon:</strong> {{ newPatientInformationForm.get('phone1')?.value }}
        </div>
        <div class="col-md-6">
          <strong>Boy:</strong> {{ newPatientInformationForm.get('height')?.value }} cm
        </div>
        <div class="col-md-6">
          <strong>Kilo:</strong> {{ newPatientInformationForm.get('weight')?.value }} kg
        </div>
        <div class="col-md-6">
          <strong>BMI:</strong> {{ calculateBMI() }}
        </div>

        <hr class="my-3" />
        <h5>Yakınlar</h5>
        <div *ngFor="let relative of patientRelativesControls; let i = index">
          <div><strong>Yakın {{ i + 1 }} Email:</strong> {{ relative.get('nextOfKinEmailAddress')?.value }}</div>
          <div><strong>Yakın {{ i + 1 }} Telefon:</strong> {{ relative.get('nextOfKinMobilePhoneNumber')?.value }}</div>
        </div>

        <hr class="my-3" />
        <div class="col-md-6">
          <strong>Doktor Telefon:</strong> {{ newPatientInformationForm.get('doctorMobilePhoneNumber')?.value }}
        </div>
        <div class="col-md-6">
          <strong>Doktor Email:</strong> {{ newPatientInformationForm.get('doctorEmailAddress')?.value }}
        </div>
      </div>
    </div>
  </div>

  <!-- 2. Alışkanlıklar -->
  <div class="accordion-item">
    <h2 class="accordion-header" id="headingTwo">
      <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseTwo"
        aria-expanded="false" aria-controls="collapseTwo">
        Alışkanlıklar
      </button>
    </h2>
    <div id="collapseTwo" class="accordion-collapse collapse" aria-labelledby="headingTwo"
      data-bs-parent="#summaryAccordion">
      <div class="accordion-body row">
        <div class="col-md-6">
          <strong>Sağlıklı Beslenme:</strong> {{ habitsForm.get('healthyEating')?.value }}
        </div>
        <div class="col-md-6">
          <strong>İlaç Kullanımı:</strong> {{ habitsForm.get('takeMedications')?.value }}
        </div>
        <div class="col-md-6">
          <strong>Hastalık Takibi:</strong> {{ habitsForm.get('monitorDisease')?.value }}
        </div>
        <div class="col-md-6">
          <strong>Aktiflik:</strong> {{ habitsForm.get('active')?.value }}
        </div>
        <div class="col-md-6">
          <strong>Stres Seviyesi:</strong> {{ habitsForm.get('stressLevel')?.value }}
        </div>
        <div class="col-md-6">
          <strong>Hipoglisemi Atakları:</strong> {{ habitsForm.get('hypoglycemicAttacks')?.value }}
        </div>
        <div class="col-md-6">
          <strong>Düşük Sodyum:</strong> {{ habitsForm.get('lowSodium')?.value }}
        </div>
        <div class="col-md-6">
          <strong>Egzersiz:</strong> {{ getHabitText(habitsForm.get('exercise')?.value)  }}
        </div>
        <div class="col-md-6">
          <strong>Egzersiz Süresi:</strong> {{ getHabitText(habitsForm.get('exerciseDuration')?.value)  }}
        </div>
      </div>
    </div>
  </div>

  <!-- 3. Hastalık Bilgileri -->
  <div class="accordion-item">
    <h2 class="accordion-header" id="headingThree">
      <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseThree"
        aria-expanded="false" aria-controls="collapseThree">
        Hastalık Bilgileri
      </button>
    </h2>
    <div id="collapseThree" class="accordion-collapse collapse" aria-labelledby="headingThree"
      data-bs-parent="#summaryAccordion">
      <div class="accordion-body">
        <!-- Diyabet Bilgileri -->
        <h5>Diyabet Bilgileri</h5>
        <div class="row">
          <div class="col-md-6">
            <strong>Diyabet:</strong> {{ diseasesInformationForm.get('hasDiabetes')?.value ? 'Evet' : 'Hayır' }}
          </div>
          <div class="col-md-6" *ngIf="diseasesInformationForm.get('hasDiabetes')?.value">
            <strong>Diyabet Tipi:</strong> {{ diabetTypeName(diseasesInformationForm.get('diabetesTypeId')?.value)}}
          </div>
          <div class="col-md-6">
            <strong>Tanı Tarihi:</strong> {{ diseasesInformationForm.get('diagnosisDate')?.value | date:'dd.MM.yyyy' }}
          </div>
          <!-- <div class="col-md-6">
            <strong>İlaç Türü:</strong> {{ diseasesInformationForm.get('oralHypoglycemic')?.value != null ? "Oral hipoglisemik" : diseasesInformationForm.get('insulin')?.value != null ? "İnsülin" : "Hayır" }}
          </div> -->
        </div>

        <hr class="my-3" />

        <!-- HbA1c ve Hedef Aralık -->
        <h5>HbA1c Bilgileri</h5>
        <div class="row">
          <div class="col-md-4">
            <strong>HbA1c:</strong> {{ diseasesInformationForm.get('hbA1cValue')?.value }}
          </div>
          <div class="col-md-4">
            <strong>Hedef Alt Sınır:</strong> {{ diseasesInformationForm.get('targetLowerLimit')?.value }}
          </div>
          <div class="col-md-4">
            <strong>Hedef Üst Sınır:</strong> {{ diseasesInformationForm.get('targetUpperLimit')?.value }}
          </div>
        </div>

        <hr class="my-3" />

        <!-- Oral Antidiyabetik -->
        <!-- <h5>Oral Antidiyabetik Kullanımı</h5>
        <div *ngIf="diseasesInformationForm.get('oralHypoglycemic')?.value">
          <div class="row" *ngFor="let time of ['Sabah', 'Öğle', 'Akşam']">
            <div class="col-md-4">
              <strong>{{ time | titlecase }} İlacı:</strong>
              {{ diseasesInformationForm.get(time + 'OralHypoglycemicMedicineName')?.value }}
            </div>
            <div class="col-md-4">
              <strong>Doz:</strong> {{ diseasesInformationForm.get(time + 'OralHypoglycemicDose')?.value }}
            </div>
            <div class="col-md-4">
              <strong>Alım Saati:</strong> {{ diseasesInformationForm.get(time + 'OralHypoglycemicTime')?.value }}
            </div>
          </div>
        </div>

        <hr class="my-3" /> -->

        <!-- İnsülin Bilgileri -->
        <!-- <h5>İnsülin Kullanımı</h5>
        <div *ngIf="diseasesInformationForm.get('insulin')?.value">
          <div class="mb-2"><strong>Uygulama Yöntemi:</strong> {{
            diseasesInformationForm.get('insulinAdministrationMethod')?.value }}</div>
          <div class="row" *ngFor="let time of ['Sabah', 'Öğle', 'Akşam']">
            <div class="col-md-3">
              <strong>{{ time | titlecase }} Doz:</strong> {{ diseasesInformationForm.get(time + 'InsulinDose')?.value
              }}
            </div>
            <div class="col-md-3">
              <strong>Alım Saati:</strong> {{ diseasesInformationForm.get(time + 'InsulinTime')?.value }}
            </div>
            <div class="col-md-6">
              <strong>İnsülin Türleri:</strong>
              <span *ngIf="diseasesInformationForm.get(time + 'InsulinNPH')?.value">NPH </span>
              <span *ngIf="diseasesInformationForm.get(time + 'InsulinLente')?.value">Lente </span>
              <span *ngIf="diseasesInformationForm.get(time + 'InsulinUltralente')?.value">Ultralente</span>
            </div>
          </div>
        </div> -->

        <!-- <hr class="my-3" /> -->

        <!-- Diğer Kronik Hastalıklar -->
        <h5>Diğer Kronik Hastalıklar</h5>
        <ul class="mb-2">
          <li *ngIf="diseasesInformationForm.get('hypertension')?.value">Hipertansiyon</li>
          <li *ngIf="diseasesInformationForm.get('cardiovascularDisease')?.value">Kardiyovasküler Hastalık</li>
          <li *ngIf="diseasesInformationForm.get('heartFailure')?.value">Kalp Yetmezliği</li>
          <li *ngIf="diseasesInformationForm.get('hyperlipidemia')?.value">Hiperlipidemi</li>
          <li *ngIf="diseasesInformationForm.get('kidneyFailure')?.value">Böbrek Yetmezliği</li>
          <li *ngIf="diseasesInformationForm.get('chronicPain')?.value">Kronik Ağrı</li>
          <li *ngIf="diseasesInformationForm.get('majorDepression')?.value">Majör Depresyon</li>
          <li *ngIf="diseasesInformationForm.get('anxiety')?.value">Anksiyete</li>
          <li *ngIf="diseasesInformationForm.get('sleepDisorder')?.value">Uyku Bozukluğu</li>
          <li *ngIf="diseasesInformationForm.get('physicalDisability')?.value">Fiziksel Engellilik</li>
          <li *ngIf="diseasesInformationForm.get('other')?.value">Diğer</li>
        </ul>

        <hr class="my-3" />

        <!-- Diğer İlaçlar -->
        <h5>Diğer İlaçlar</h5>
        <div class="row" *ngFor="let time of times">
          <div class="col-md-3">
            <strong>{{ getMedicationName(diseasesInformationForm.get('otherMed_' + time.id + 'Name')?.value) }}</strong>
          </div>
          <div class="col-md-3">
            <strong>Doz:</strong> {{ diseasesInformationForm.get('otherMed_' + time.id + 'Dose')?.value  }}
          </div>
          <div class="col-md-3">
            <strong>Alım Saati:</strong> {{ diseasesInformationForm.get('otherMed_' + time.id + 'Time')?.value  }}
          </div>
          
        </div>
      </div>
    </div>
  </div>


  <!-- 4. Hedefler -->
  <div class="accordion-item">
    <h2 class="accordion-header" id="headingFour">
      <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseFour"
        aria-expanded="false" aria-controls="collapseFour">
        Hedefler
      </button>
    </h2>
    <div id="collapseFour" class="accordion-collapse collapse" aria-labelledby="headingFour"
      data-bs-parent="#summaryAccordion">
      <div class="accordion-body row">
        <div *ngFor="let key of goalsFormKeys" class="col-md-6 mb-2">
          <strong>{{ key | translate }}:</strong> {{ goalsForm.get(key)?.value }}
        </div>
      </div>
    </div>
  </div>

  <!-- 5. Takip Ayarları -->
  <div class="accordion-item">
    <h2 class="accordion-header" id="headingFive">
      <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseFive"
        aria-expanded="false" aria-controls="collapseFive">
        Takip Ayarları
      </button>
    </h2>
    <div id="collapseFive" class="accordion-collapse collapse" aria-labelledby="headingFive"
      data-bs-parent="#summaryAccordion">
      <div class="accordion-body row">
        <div class="col-md-6">
          <strong>Hipoglisemi Eşiği:</strong> {{ caseSettingForm.get('hypoglycemiaThreshold')?.value }}
        </div>
        <div class="col-md-6">
          <strong>Açlık Glikoz Eşiği:</strong> {{ caseSettingForm.get('fastingGlucoseThreshold')?.value }}
        </div>
        <div class="col-md-6">
          <strong>Tokluk Glikoz Eşiği:</strong> {{ caseSettingForm.get('postprandialGlucoseThreshold')?.value }}
        </div>
        <div class="col-md-6">
          <strong>HbA1c Eşiği:</strong> {{ caseSettingForm.get('hba1cThreshold')?.value }}
        </div>
        <div class="col-md-6">
          <strong>Takip Süresi:</strong> {{ caseSettingForm.get('followUpDurationDays')?.value }} gün
        </div>
        <div class="col-md-6">
          <strong>Bildirimler Devre Dışı:</strong>
          {{ caseSettingForm.get('disableNotificationsAfterFollowUp')?.value ? 'Evet' : 'Hayır' }}
        </div>
      </div>
    </div>
  </div>

  <!-- Save Button -->
    <div class="text-end mt-5">
        <button (click)="savePreparation($event)" type="button" class="btn btn-sm btn-primary cursor-pointer">
            {{ "save" | translate }}
        </button>
    </div>
</div>